export function isProd() {
  const APP_ENV = String(process.env.REACT_APP_ENV || 'LOCAL');
  return APP_ENV === 'PROD';
}

export function isStaging() {
  const APP_ENV = String(process.env.REACT_APP_ENV || 'LOCAL');
  return APP_ENV === 'STAGING';
}
